import { Directive, Component } from '@angular/core'
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms'
import { FieldType } from '@ngx-formly/core'

@Directive({
    selector: 'input[type=file]',
   
    host: {
        '(change)': 'onChange($event.target.files)',
        '(blur)': 'onTouched()'
    },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FileValueAccessorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class FileValueAccessorDirective implements ControlValueAccessor {
    value: any
    onChange = (_) => {}
    onTouched = () => {}

    writeValue(_value: any) {}
    registerOnChange(fn: any) {
        this.onChange = fn
    }
    registerOnTouched(fn: any) {
        this.onTouched = fn
    }
}

@Component({
    selector: 'formly-field-file',
    template: ` <input type="file" [formControl]="formControl" [formlyAttributes]="field" /> `,
    standalone: false
})
export class FormlyFieldFileComponent extends FieldType {}
